import { render, staticRenderFns } from "./OrgCardList.vue?vue&type=template&id=5a988e2a"
import script from "./OrgCardList.vue?vue&type=script&lang=js"
export * from "./OrgCardList.vue?vue&type=script&lang=js"
import style0 from "./OrgCardList.vue?vue&type=style&index=0&id=5a988e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports